<mat-button-toggle-group
  [value]="value"
  [disabled]="disabled"
  [attr.aria-labelledby]="ariaLabelledby"
  hideSingleSelectionIndicator
  (change)="onToggleChange($event)">
  <mat-button-toggle [value]="yesValue">{{ yesLabel }}</mat-button-toggle>
  <mat-button-toggle [value]="noValue">{{ noLabel }}</mat-button-toggle>
</mat-button-toggle-group>
